import { useContext } from 'react';
import { MainContext } from 'components/layout/MainContext';

export const useIsSessionOpen = (): boolean => {
    const { session } = useContext(MainContext);

    return session?.token !== null && session !== null;
};
